import startCase from "lodash/startCase";

/**
 *
 * @param {string} name
 * @returns two character string with the first and last initials of the name, Jin Y Choi -> JC
 */
export const getFirstLastInitials = (name) => {
    if (!name) {
        return "";
    }
    const names = name.split(" ").filter((n) => n);
    if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
    }
    return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
};

/**
 * @param {string} name
 * @returns the first word of the name, e.g. "Jin Y Choi" -> "Jin"
 */
export const getFirstName = (name) => {
    if (!name) {
        return "";
    }
    return name.trim().split(/\s+/)[0] ?? "";
};

/**
 * @param {string} name
 * @returns the last word of the name, e.g. "Jin Y Choi" -> "Choi"
 */
export const getLastName = (name) => {
    if (!name) {
        return "";
    }
    const parts = name.trim().split(/\s+/);
    return parts[parts.length - 1] ?? "";
};

export const convertSnakeCaseToDisplay = (snakeCaseStr) => startCase(snakeCaseStr.replace(/_/g, " ").toLowerCase());

/**
 * @param {String} word
 * @returns 'a' or 'an' based on the first letter of the word
 */
export const articleFor = (word) => {
    if (!word) {
        return "";
    }
    return "aeiou".includes(word.charAt(0).toLowerCase()) ? "an" : "a";
};

/**
 * @param {String} word
 * @returns word prefixed with the correct article 'a' or 'an'
 */
export const prefixArticle = (word) => {
    if (!word || word.length === 0) {
        return word;
    }
    return `${articleFor(word)} ${word}`;
};

/**
 *
 * @param {String} name
 * @returns possessive form of the name (e.g. "John" -> "John's", "James" -> "James'")
 */
export const getPossessiveName = (name) => {
    if (!name || name.length === 0) {
        return name;
    }
    return name.endsWith("s") ? `${name}'` : `${name}'s`;
};

/**
 * Get initials from a name (first + last, or first 2 chars if single word)
 *
 * @param {string} name - The name to extract initials from
 * @returns {string} Initials in uppercase (e.g. "John Doe" -> "JD", "John" -> "JO")
 */
export const getInitials = (name) => {
    if (!name) {
        return "";
    }

    const parts = name.trim().split(/\s+/);
    const first = parts[0];
    const last = parts[parts.length - 1];

    if (parts.length >= 2 && first && last) {
        return (first[0] + last[0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};

/**
 * capitalizes a name
 * jin choi -> Jin Choi
 *
 * @param {string} name
 * @returns {string} capitalized name
 */
export const capitalizeName = (name) => name.replace(/\b\w/g, (char) => char.toUpperCase());

/**
 * @param {string} fullName
 * @returns {string} first whitespace-delimited token of the name (e.g. "Jin Y Choi" -> "Jin")
 */
export const firstNameOf = (fullName) => fullName.trim().split(/\s+/)[0] || fullName.trim();
